var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-around flex-column flex-md-row flex-lg-row border-bottom pb-2"},_vm._l((_vm.pasos),function(paso){return _c('paso',{key:paso.key,staticClass:"paso",attrs:{"id":paso.id,"nombre":paso.nombre,"activo":paso.id==_vm.pasoActivo}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30dc4c20","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pasos.vue
// module id = 188
// module chunks = 0